export enum PermissionsConstrains {
  ACTIVITIES_EMPLOYEE = "activities/employee",
  BUSINESS_BILL = "business/bill",
  BUSINESS_BUSINESS = "business/business",
  BUSINESS_COUNTRY = "business/country",
  BUSINESS_CREDIT_CARD = "business/credit_card",
  BUSINESS_CURRENCY = "business/currency",
  BUSINESS_DISCOUNT = "business/discount",
  BUSINESS_DRAWER = "business/drawer",
  BUSINESS_EMPLOYEE = "business/employee",
  BUSINESS_EXCHANGE = "business/exchange",
  BUSINESS_EXTRA_CHARGE = "business/extra_charge",
  BUSINESS_LOCATION = "business/location",
  BUSINESS_MESSAGE = "business/message",
  BUSINESS_ORDER_OPTION = "business/order_option",
  BUSINESS_PAGE = "business/page",
  BUSINESS_PAYMENT = "business/payment",
  BUSINESS_PAYMENT_CATEGORY = "business/payment_category",
  BUSINESS_PAYMENT_GATEWAY = "business/payment_gateway",
  BUSINESS_PAYMENT_METHOD = "business/payment_method",
  BUSINESS_PAYMENT_PROCESSOR = "business/payment_processor",
  BUSINESS_PROFILE = "business/profile",
  BUSINESS_RECEIPT = "business/receipt",
  BUSINESS_REGISTER = "business/register",
  BUSINESS_SERVICE = "business/service",
  BUSINESS_TIMEZONE = "business/timezone",
  BUSINESS_USER = "business/user",
  BUSINESS_MENU = "business/menu",
  CATALOG_CATEGORY = "catalog/category",
  CATALOG_ITEM = "catalog/item",
  CATALOG_MODIFIER = "catalog/modifier",
  CATALOG_MODIFIER_LIST = "catalog/modifier_list",
  CATALOG_TAG = "catalog/tag",
  CATALOG_TAX = "catalog/tax",
  CHECKOUT_ORDER = "checkout/order",
  CUSTOMERS_AREA = "customers/area",
  CUSTOMERS_AVENUE = "customers/avenue",
  CUSTOMERS_BLOCK = "customers/block",
  CUSTOMERS_CITY = "customers/city",
  CUSTOMERS_CUSTOMER = "customers/customer",
  CUSTOMERS_PAYMENT = "customers/payment",
  CUSTOMERS_TAG = "customers/tag",
  DELIVERY_CATEGORY = "delivery/category",
  DELIVERY_COST = "delivery/cost",
  DELIVERY_DRIVER = "delivery/driver",
  INVENTORY_ACTIVITY = "inventory/activity",
  INVENTORY_CATEGORY = "inventory/category",
  INVENTORY_CONSUMPTION = "inventory/consumption",
  INVENTORY_GOOD = "inventory/good",
  INVENTORY_INGREDIENT = "inventory/ingredient",
  INVENTORY_LOW_STOCK = "inventory/low_stock",
  INVENTORY_PURCHASE = "inventory/purchase",
  INVENTORY_RECIPE = "inventory/recipe",
  INVENTORY_STOCKTAKE = "inventory/stocktake",
  INVENTORY_SUBRECIPE = "inventory/subrecipe",
  INVENTORY_SUPPLIER = "inventory/supplier",
  INVENTORY_TRANSFER = "inventory/transfer",
  LAUNCHPAD_APPLICATION = "launchpad/application",
  LAUNCHPAD_DELIVERY = "launchpad/delivery",
  LAUNCHPAD_LOYALTY = "launchpad/loyalty",
  NOTIFICATIONS_TRIGGER = "notifications/trigger",
  RECKO_ITEM = "recko/item",
  RECKO_MODIFIER = "recko/modifier",
  RECKO_VARIATION = "recko/variation",
  REPORTS_CATEGORY = "reports/category",
  REPORTS_COMPARISON = "reports/comparison",
  REPORTS_CUSTOMER = "reports/customer",
  REPORTS_DAY_IN_RANGE = "reports/day_in_range",
  REPORTS_DAY_OF_WEEK = "reports/day_of_week",
  REPORTS_DELIVERY = "reports/delivery",
  REPORTS_DISCOUNT = "reports/discount",
  REPORTS_EMPLOYEE = "reports/employee",
  REPORTS_END_OF_DAY = "reports/end_of_day",
  REPORTS_FAVORITE = "reports/favorite",
  REPORTS_GROWTH = "reports/growth",
  REPORTS_GROWTH_GOAL = "reports/growth_goal",
  REPORTS_ITEM = "reports/item",
  REPORTS_ITEM_ANALYSIS = "reports/item_analysis",
  REPORTS_MODIFIER = "reports/modifier",
  REPORTS_ORDER_OPTION = "reports/order_option",
  REPORTS_PAYMENT_METHOD = "reports/payment_method",
  REPORTS_REALTIME = "reports/realtime",
  REPORTS_SUMMARY = "reports/summary",
  REPORTS_TARGET = "reports/target",
  REPORTS_TAX = "reports/tax",
  REPORTS_TIME_OF_DAY = "reports/time_of_day",
  REPORTS_TOTALS = "reports/totals",
  REPORTS_TRANSACTIONS = "reports/transactions",
  TABS_CATEGORY = "tabs/category",
  TABS_LAYOUT = "tabs/layout",
  TABS_TAB = "tabs/tab",
  TABS_TEMPLATE = "tabs/template",
  TABS_VOID_REASON = "tabs/void_reason",
  TABS_REPORTING_TAB = "tabs_reporting/tab",
  TABS_REPORTING_VOID = "tabs_reporting/void",
  TRANSACTIONS_REFUND = "transactions/refund",
  TRANSACTIONS_SALE = "transactions/sale",
  CALL_CENTER = "call_center/access",
  UNITS = "units",
}
